import React, { useState, useEffect, useCallback } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import Pill from "../../Pill/pill";
import Button from "../../Buttons/button";
import RadioButton from "../../RadioButton/RadioButton";
import {
  companySubmissionDetail,
  selectCompanyDashboard,
} from "../../../redux/slices/companyDashboardSlice";
import {
  createSubmissionComments,
  selectPersonalDashboard,
  statusUpdateSubmission,
} from "../../../redux/slices/personalDashboardSlice";
import { selectUser } from "../../../redux/slices/userSlice";

import { useDispatch, useSelector } from "react-redux";
import { formatDate } from "../../../modules/feedbacker/feedback-module/feedbackModule";
import { getInitials } from "../../../shared/lib/getInitials";

function SubmittedServicesInfoModel({
  setstate,
  setPopup,
  model = false,
  show,
  setShow,
  tablename,
  id,
}) {
  const [Words, setWords] = useState("");
  const [openbutton, setOpenbutton] = useState(false);
  const [commentsData, setCommentsData] = useState(false);
  const [editStatus, setEditStatus] = useState(false);
  const userData = useSelector(selectUser);
  const personalData = useSelector(selectPersonalDashboard);
  const dispatch = useDispatch();
  const State = useSelector(selectCompanyDashboard);

  const { submissionDetailsData, updateStatusSubmission } = personalData;
  const { companySubmissionDetailData } = State;
  const { submission } = companySubmissionDetailData || {};
  const { userDetails } = userData;

  useEffect(() => {
    dispatch(companySubmissionDetail(id.id, id.user_id));
    setOpenbutton();
    setCommentsData(false);
  }, [
    commentsData,
    openbutton,
    updateStatusSubmission,
    id.id,
    id.user_id,
    dispatch,
  ]);

  const postComment = () => {
    dispatch(
      createSubmissionComments(id.id, {
        comment: {
          user_id: userDetails?.user?.id,
          content: Words,
        },
      })
    );
    // setPopup(false);
    setCommentsData(true);
    setWords("");
  };

  const initials = getInitials(submission?.submitted_by_detail);

  const handleInput = useCallback(
    async (field, value) => {
      await dispatch(
        statusUpdateSubmission(id.id, {
          status: value,
          user_id: id.user_id || -1,
        })
      );
      setOpenbutton(!openbutton);
    },
    [dispatch, id.id, id.user_id, openbutton]
  );

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      postComment();
    }
  };

  const showEditStatus = () => {
    setEditStatus(!editStatus);
  };

  return (
    <div
      className={`flex flex-col bg-[#363D50] rounded-[24px] relative w-[350px] h-[650px] scrollbar-hide md:w-[591px] lg:w-[591px] xl:w-[591px] 2xl:w-[591px] overflow-y-scroll scrollbar-hide`}
    >
      <div className="sticky left-0 right-0 top-0 bg-[#363D50]">
        <div className="flex items-center justify-between px-[24px] py-[16px]">
          <div className="flex flex-start items-center gap-[16px]">
            <div className="flex justify-center items-center bg-[#242B3E] w-[48px] h-[48px] rounded-[16px] ">
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M14.7044 3.53243C15.1741 3.22938 15.6872 3.05878 16.2351 3.05878C16.5881 3.05878 16.8814 3.1411 17.116 3.27096C17.3718 3.41256 17.6939 3.31999 17.8355 3.0642C17.9771 2.8084 17.8846 2.48625 17.6288 2.34465C17.2283 2.12296 16.757 2 16.2351 2C15.4566 2 14.747 2.24493 14.1304 2.64277C13.8847 2.80128 13.814 3.12894 13.9726 3.37462C14.1311 3.62029 14.4587 3.69094 14.7044 3.53243ZM18.842 3.85607C18.7584 3.57593 18.4634 3.41667 18.1833 3.50035C17.9031 3.58403 17.7439 3.87897 17.8275 4.15911C17.9097 4.43407 17.9187 4.73924 17.8401 5.04417C17.7763 5.29143 17.6818 5.48968 17.5678 5.64678C17.438 5.82576 17.4365 6.05871 17.5458 6.23589H17.4372C17.2981 6.11172 17.0975 6.06495 16.9091 6.13102C16.717 6.19838 16.4922 6.23586 16.2351 6.23586C15.9428 6.23586 15.7058 6.47287 15.7058 6.76524C15.7058 7.05762 15.9428 7.29463 16.2351 7.29463C16.2863 7.29463 16.3371 7.29357 16.3876 7.29143C16.407 7.29357 16.4266 7.29466 16.4465 7.29466H18.3523C18.849 7.29466 19.1544 7.39412 19.348 7.519C19.5938 7.67745 19.9214 7.60671 20.0798 7.361C20.2383 7.11528 20.1675 6.78764 19.9218 6.62919C19.529 6.3759 19.0378 6.24904 18.4474 6.23686C18.6365 5.96745 18.7758 5.65564 18.8653 5.3085C18.9917 4.81824 18.9797 4.31688 18.842 3.85607ZM13.1729 5.23934C13.3168 4.98484 13.2272 4.66186 12.9727 4.51793C12.7182 4.374 12.3952 4.46363 12.2513 4.71813C12.1564 4.88583 12.0679 5.05766 11.986 5.23249C11.9047 5.06243 11.8177 4.89508 11.7251 4.73151C11.5811 4.47708 11.2581 4.3876 11.0036 4.53164C10.7492 4.67568 10.6597 4.9987 10.8038 5.25313C10.981 5.56611 11.1357 5.89723 11.2661 6.23589H10.0938C9.80144 6.23589 9.56442 6.4729 9.56442 6.76528C9.56442 7.05765 9.80144 7.29466 10.0938 7.29466H11.9893C11.9963 7.2948 12.0033 7.29481 12.0103 7.29466H13.9054C14.1978 7.29466 14.4348 7.05765 14.4348 6.76528C14.4348 6.4729 14.1978 6.23589 13.9054 6.23589H12.7149C12.8396 5.89296 12.9932 5.55697 13.1729 5.23934ZM6.43227 5.64678C6.56211 5.82576 6.56362 6.05871 6.45429 6.23589H6.56291C6.70201 6.11172 6.90263 6.06495 7.09103 6.13102C7.28314 6.19838 7.5079 6.23586 7.76497 6.23586C8.05734 6.23586 8.29436 6.47287 8.29436 6.76524C8.29436 7.05762 8.05734 7.29463 7.76497 7.29463C7.71363 7.29463 7.66257 7.29356 7.61183 7.2914C7.59243 7.29356 7.57272 7.29466 7.55275 7.29466H5.64694C5.1502 7.29466 4.84486 7.39412 4.65119 7.519C4.40547 7.67745 4.07783 7.60671 3.91938 7.361C3.76093 7.11528 3.83168 6.78764 4.07739 6.62919C4.47038 6.37577 4.96196 6.24891 5.55267 6.23684C5.36359 5.96743 5.22429 5.65563 5.13479 5.3085C5.00839 4.81824 5.02043 4.31688 5.15808 3.85607C5.24177 3.57593 5.5367 3.41667 5.81685 3.50035C6.09699 3.58403 6.25625 3.87897 6.17257 4.15911C6.09044 4.43407 6.08142 4.73924 6.16004 5.04417C6.22379 5.29143 6.31831 5.48968 6.43227 5.64678ZM20.9447 8.54303C20.9097 8.25277 20.6459 8.04588 20.3557 8.08094C20.0654 8.11599 19.8585 8.37972 19.8936 8.66998C19.9397 9.05218 19.9404 9.47666 19.9404 9.94161C19.9404 10.3583 19.9402 10.7459 19.9141 11.1008C19.8926 11.3924 20.1116 11.6461 20.4032 11.6676C20.6948 11.689 20.9486 11.47 20.97 11.1784C20.9992 10.7811 20.9992 10.3571 20.9992 9.9524V9.9247C20.9992 9.47888 20.9992 8.9945 20.9447 8.54303ZM4.10565 8.66998C4.1407 8.37972 3.93382 8.11599 3.64355 8.08094C3.35329 8.04588 3.08956 8.25277 3.05451 8.54303C2.99998 8.9945 2.99999 9.47887 3 9.92468V9.92469V9.95238V9.95255C3 10.3572 3 10.7812 3.02922 11.1784C3.05066 11.47 3.30442 11.689 3.59601 11.6676C3.8876 11.6461 4.10659 11.3924 4.08514 11.1008C4.05904 10.7459 4.05878 10.3583 4.05878 9.94161C4.05878 9.47666 4.05949 9.05218 4.10565 8.66998ZM20.3603 12.9897C20.5558 12.7723 20.538 12.4376 20.3205 12.2421C20.1031 12.0466 19.7684 12.0644 19.5729 12.2819C19.4582 12.4095 19.2694 12.5218 18.8817 12.5218C18.5893 12.5218 18.3523 12.7589 18.3523 13.0512V14.3418C18.3523 14.6342 18.5893 14.8712 18.8817 14.8712C19.174 14.8712 19.4111 14.6342 19.4111 14.3418V13.5272C19.7933 13.4445 20.1122 13.2657 20.3603 12.9897ZM4.42629 12.2819C4.23083 12.0644 3.89611 12.0466 3.67868 12.2421C3.46124 12.4376 3.44343 12.7723 3.63889 12.9897C3.88698 13.2657 4.20594 13.4445 4.58817 13.5272V14.3418C4.58817 14.6342 4.82518 14.8712 5.11756 14.8712C5.40993 14.8712 5.64694 14.6342 5.64694 14.3418V13.0512C5.64694 12.7589 5.40993 12.5218 5.11756 12.5218C4.72987 12.5218 4.541 12.4095 4.42629 12.2819ZM5.64694 16.0625C5.64694 15.7701 5.40993 15.5331 5.11756 15.5331C4.82518 15.5331 4.58817 15.7701 4.58817 16.0625V17.3531C4.58817 17.7849 4.69197 18.194 4.87646 18.5553C5.00941 18.8157 5.32828 18.9191 5.58868 18.7861C5.84908 18.6532 5.9524 18.3343 5.81945 18.0739C5.70931 17.8582 5.64694 17.6137 5.64694 17.3531V16.0625ZM19.4111 16.0625C19.4111 15.7701 19.174 15.5331 18.8817 15.5331C18.5893 15.5331 18.3523 15.7701 18.3523 16.0625V17.3531C18.3523 17.6137 18.2899 17.8582 18.1798 18.0739C18.0468 18.3343 18.1501 18.6532 18.4105 18.7861C18.6709 18.9191 18.9898 18.8157 19.1228 18.5553C19.3072 18.194 19.4111 17.7849 19.4111 17.3531V16.0625ZM6.51427 18.7687C6.25387 18.6358 5.935 18.7391 5.80206 18.9995C5.66911 19.2599 5.77243 19.5788 6.03283 19.7117C6.39419 19.8962 6.8033 20 7.23511 20H8.66446C8.95684 20 9.19385 19.763 9.19385 19.4706C9.19385 19.1782 8.95684 18.9412 8.66446 18.9412H7.23511C6.97451 18.9412 6.73001 18.8789 6.51427 18.7687ZM17.9664 19.7117C18.2268 19.5788 18.3301 19.2599 18.1972 18.9995C18.0642 18.7391 17.7453 18.6358 17.485 18.7687C17.2692 18.8789 17.0247 18.9412 16.7641 18.9412H15.3348C15.0424 18.9412 14.8054 19.1782 14.8054 19.4706C14.8054 19.763 15.0424 20 15.3348 20H16.7641C17.1959 20 17.605 19.8962 17.9664 19.7117ZM10.5703 18.9412C10.2779 18.9412 10.0409 19.1782 10.0409 19.4706C10.0409 19.763 10.2779 20 10.5703 20H13.429C13.7213 20 13.9584 19.763 13.9584 19.4706C13.9584 19.1782 13.7213 18.9412 13.429 18.9412H10.5703ZM7.76497 3.05878C8.31472 3.05878 8.82201 3.23047 9.28504 3.53489C9.52934 3.6955 9.85759 3.62766 10.0182 3.38336C10.1788 3.13905 10.111 2.8108 9.86668 2.65018C9.25452 2.24772 8.54798 2 7.76497 2C7.24316 2 6.7718 2.12296 6.37135 2.34465C6.11555 2.48625 6.02298 2.8084 6.16459 3.0642C6.30619 3.31999 6.62835 3.41256 6.88414 3.27096C7.11871 3.1411 7.41206 3.05878 7.76497 3.05878ZM12.5292 10.0295C12.5292 9.73709 12.2922 9.50007 11.9998 9.50007C11.7074 9.50007 11.4704 9.73709 11.4704 10.0295V12.5889H9C8.70762 12.5889 8.47061 12.8259 8.47061 13.1182C8.47061 13.4106 8.70762 13.6476 9 13.6476H11.4704V16.0001C11.4704 16.2924 11.7074 16.5295 11.9998 16.5295C12.2922 16.5295 12.5292 16.2924 12.5292 16.0001V13.6476H15C15.2924 13.6476 15.5294 13.4106 15.5294 13.1182C15.5294 12.8259 15.2924 12.5889 15 12.5889H12.5292V10.0295Z"
                  fill="white"
                />
              </svg>
            </div>
            <div className="flex items-center">
              <span className="text-primary !text-left">
                {submission?.type ?? "New"} Service Submission
              </span>
            </div>
          </div>

          {!model ? (
            <div className="flex h-[40px] justify-end items-center">
              <svg
                className="cursor-pointer"
                onClick={() => {
                  setPopup(false);
                }}
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.4099 12.0002L17.7099 7.71019C17.8982 7.52188 18.004 7.26649 18.004 7.00019C18.004 6.73388 17.8982 6.47849 17.7099 6.29019C17.5216 6.10188 17.2662 5.99609 16.9999 5.99609C16.7336 5.99609 16.4782 6.10188 16.2899 6.29019L11.9999 10.5902L7.70994 6.29019C7.52164 6.10188 7.26624 5.99609 6.99994 5.99609C6.73364 5.99609 6.47824 6.10188 6.28994 6.29019C6.10164 6.47849 5.99585 6.73388 5.99585 7.00019C5.99585 7.26649 6.10164 7.52188 6.28994 7.71019L10.5899 12.0002L6.28994 16.2902C6.19621 16.3831 6.12182 16.4937 6.07105 16.6156C6.02028 16.7375 5.99414 16.8682 5.99414 17.0002C5.99414 17.1322 6.02028 17.2629 6.07105 17.3848C6.12182 17.5066 6.19621 17.6172 6.28994 17.7102C6.3829 17.8039 6.4935 17.8783 6.61536 17.9291C6.73722 17.9798 6.86793 18.006 6.99994 18.006C7.13195 18.006 7.26266 17.9798 7.38452 17.9291C7.50638 17.8783 7.61698 17.8039 7.70994 17.7102L11.9999 13.4102L16.2899 17.7102C16.3829 17.8039 16.4935 17.8783 16.6154 17.9291C16.7372 17.9798 16.8679 18.006 16.9999 18.006C17.132 18.006 17.2627 17.9798 17.3845 17.9291C17.5064 17.8783 17.617 17.8039 17.7099 17.7102C17.8037 17.6172 17.8781 17.5066 17.9288 17.3848C17.9796 17.2629 18.0057 17.1322 18.0057 17.0002C18.0057 16.8682 17.9796 16.7375 17.9288 16.6156C17.8781 16.4937 17.8037 16.3831 17.7099 16.2902L13.4099 12.0002Z"
                  fill="white"
                />
              </svg>
            </div>
          ) : (
            <div className="flex h-[40px] justify-end items-center">
              <svg
                onClick={() => {
                  setShow(!show);
                }}
                className="cursor-pointer"
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.5001 3.08984L15.0001 7.58984V3.99984H13.0001V10.9998H20.0001V8.99984H16.4101L20.9101 4.49984L19.5001 3.08984ZM4.00009 12.9998V14.9998H7.59009L3.09009 19.4998L4.50009 20.9098L9.00009 16.4098V19.9998H11.0001V12.9998H4.00009Z"
                  fill="white"
                />
              </svg>
            </div>
          )}
        </div>
        <div className="h-[2px] bg-[#41485C] absolute left-[24px] right-[24px]" />
      </div>

      <div className="flex flex-col px-[24px] py-[24px] gap-[24px]">
        <div className="w-full flex flex-col pb-[8px]">
          <div className="flex items-center">
            <span className="text-primary !text-left !text-[24px] !leading-[36px] mb-[10px]">
              {submission?.service_name}
            </span>
          </div>

          <div className="flex py-[8px] gap-[4px] items-center justify-left">
            <div className="w-[156px] h-[20px] flex items-center !text-left">
              <span className="text-secondary !leading-[20px]">
                Submission Type
              </span>
            </div>
            <div>
              <Pill fill={true}>{submission?.type}</Pill>
            </div>
          </div>

          <div className="flex py-[8px] gap-[4px] items-center justify-left">
            <div className="w-[156px] h-[20px] flex items-center !text-left">
              <span className="text-secondary !leading-[20px]">Category</span>
            </div>
            <div className="flex gap-[8px] items-center">
              {submission?.categories_name_array.map((item, index) => (
                <Pill key={index} outline={true}>
                  {" "}
                  {item}{" "}
                </Pill>
              ))}
            </div>
          </div>

          <div className="flex py-[8px] gap-[4px] items-center justify-left">
            <div className="w-[156px] h-[20px] flex items-center !text-left">
              <span className="text-secondary !leading-[20px]">Status</span>
            </div>
            <div className="flex gap-[8px] items-center">
              {companySubmissionDetailData?.submission?.status === "open" && (
                <Pill
                  greenFill={true}
                  className="!text-[12px] !py-[4px] !px-[6px]"
                >
                  {companySubmissionDetailData?.submission?.status}
                </Pill>
              )}
              {companySubmissionDetailData?.submission?.status === "closed" && (
                <Pill
                  redFill={true}
                  className="!text-[12px] !py-[4px] !px-[6px]"
                >
                  {companySubmissionDetailData?.submission?.status}
                </Pill>
              )}
              {companySubmissionDetailData?.submission?.status ===
                "approved" && (
                <Pill
                  yellowFill={true}
                  className="!text-[12px] !py-[4px] !px-[6px]"
                >
                  {companySubmissionDetailData?.submission?.status}
                </Pill>
              )}
              <div className="flex items-center justify-center relative">
                <button onClick={() => showEditStatus()}>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.0833 7.43734L12.5417 3.93734L13.7083 2.77067C14.0278 2.45123 14.4203 2.2915 14.8858 2.2915C15.3508 2.2915 15.7431 2.45123 16.0625 2.77067L17.2292 3.93734C17.5486 4.25678 17.7153 4.64234 17.7292 5.094C17.7431 5.54511 17.5903 5.93039 17.2708 6.24984L16.0833 7.43734ZM3.33333 17.4998C3.09722 17.4998 2.89944 17.4198 2.74 17.2598C2.58 17.1004 2.5 16.9026 2.5 16.6665V14.3123C2.5 14.2012 2.52083 14.0937 2.5625 13.9898C2.60417 13.8854 2.66667 13.7915 2.75 13.7082L11.3333 5.12484L14.875 8.6665L6.29167 17.2498C6.20833 17.3332 6.11472 17.3957 6.01083 17.4373C5.90639 17.479 5.79861 17.4998 5.6875 17.4998H3.33333Z"
                      fill="#636F82"
                    />
                  </svg>
                </button>
                {editStatus && (
                  <OutsideClickHandler
                    onOutsideClick={() => {
                      setEditStatus(false);
                    }}
                  >
                    <div className="absolute top-[24px] left-[0px] w-[120px] z-50 bg-[#293043] p-2 rounded-xl">
                      <div className="flex gap-[8px] items-center">
                        <RadioButton
                          small={true}
                          checked={
                            companySubmissionDetailData?.submission?.status ===
                            "open"
                          }
                          onChange={() => handleInput("status", "open")}
                        />
                        <div className="flex items-center">
                          <span
                            className="text-secondary !font-normal !leading-[20px] cursor-pointer"
                            onClick={() => handleInput("status", "open")}
                          >
                            Open
                          </span>
                        </div>
                      </div>
                      <div className="flex gap-[8px] items-center mt-1">
                        <RadioButton
                          small={true}
                          checked={
                            companySubmissionDetailData?.submission?.status ===
                            "closed"
                          }
                          onChange={() => handleInput("status", "closed")}
                        />
                        <div className="flex items-center">
                          <span
                            className="text-secondary !font-normal !leading-[20px] cursor-pointer"
                            onClick={() => handleInput("status", "closed")}
                          >
                            Close
                          </span>
                        </div>
                      </div>
                      <div className="flex gap-[8px] items-center mt-1">
                        <RadioButton
                          small={true}
                          checked={
                            companySubmissionDetailData?.submission?.status ===
                            "approved"
                          }
                          onChange={() => handleInput("status", "approved")}
                        />
                        <div className="flex items-center">
                          <span
                            className="text-secondary !font-normal !leading-[20px] cursor-pointer"
                            onClick={() => handleInput("status", "approved")}
                          >
                            Approve
                          </span>
                        </div>
                      </div>
                    </div>
                  </OutsideClickHandler>
                )}
              </div>
            </div>
          </div>

          <div className="flex py-[8px] gap-[4px] items-center justify-left">
            <div className="w-[156px] h-[20px] flex items-center !text-left">
              <span className="text-secondary !leading-[20px]">Website</span>
            </div>
            <div className="flex gap-[8px] items-center">
              <Pill link={true} className={"!px-[0px]"} />
              <a
                href={`https://${submission?.website_url}`}
                target="_blank"
                className="text-primary !text-[#FFD74A] !text-left !font-normal !text-[14px]"
                rel="noreferrer"
              >
                {submission?.website_url}
              </a>
            </div>
          </div>

          <div className="flex py-[8px] gap-[4px] items-center justify-left">
            <div className="w-[156px] h-[20px] flex items-center !text-left">
              <span className="text-secondary !leading-[20px]">Expensed</span>
            </div>
            <div className="flex gap-[8px] pl-0  px-[24px]">
              <span>
                {submission?.is_expensed ? (
                  <Pill fill={true} check={true} greenFill={true} />
                ) : (
                  <Pill fill={true} cross={true} redFill={true} />
                )}
              </span>
              <span className="text-primary !text-left !font-normal !text-[14px]">
                {submission?.expensed_detail}
              </span>
            </div>
          </div>

          <div className="flex py-[8px] gap-[4px] items-center justify-left">
            <div className="w-[156px] h-[20px] flex items-center !text-left">
              <span className="text-secondary !leading-[20px]">
                Submitted By{" "}
              </span>
            </div>
            <div className="flex gap-2  items-center">
              <div className="rounded-full bg-[#2284FF]/[15%] to-white !text-[#2284FF] !text-[11px] !text-center w-[24px] h-[24px] text-primary flex justify-center items-center pl-[2px] pt-[1px]">
                {initials}
              </div>
              <div>
                <span className="text-primary !text-left !font-normal !text-[14px]">
                  {submission?.submitted_by_detail}
                </span>
              </div>
            </div>
          </div>

          <div className="flex py-[8px] gap-[4px] items-center justify-left">
            <div className="w-[156px] h-[20px] flex items-center !text-left">
              <span className="text-secondary !leading-[20px]">Submitted</span>
            </div>
            <div className="flex gap-[4px]">
              <span className="text-primary !text-left !font-normal !text-[14px]">
                {submission?.submitted_on}
              </span>
            </div>
          </div>
        </div>

        <div className="flex flex-col py-[8px] gap-[8px]">
          <span className="text-primary !text-left !leading-[21px] !font-extrabold">
            Reason for service suggestion
          </span>
          <span className="text-secondary !text-left !leading-[21px]">
            {" "}
            {submission?.suggesting_reason_detail}{" "}
          </span>
          {submission?.submission_details !== "Not Provided" && (
            <span className="text-secondary !text-left !leading-[20px]">
              {" "}
              {submission?.submission_details}
            </span>
          )}
        </div>
        <div className="w-full h-[2px] bg-[#41485C]" />
        <div className="flex flex-col gap-[24px]">
          <div className=" flex flex-col h-auto overflow-y-auto scrollbar-hide gap-[12px]">
            <div className="flex w-full gap-[4px] items-center bg-[#363D50]">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.25 1.25C6.5266 1.25165 4.87426 1.93701 3.65563 3.15563C2.43701 4.37426 1.75165 6.0266 1.75 7.75V13.0188C1.75 13.3453 1.87972 13.6585 2.11062 13.8894C2.34153 14.1203 2.6547 14.25 2.98125 14.25H8.25C9.97391 14.25 11.6272 13.5652 12.8462 12.3462C14.0652 11.1272 14.75 9.47391 14.75 7.75C14.75 6.02609 14.0652 4.37279 12.8462 3.15381C11.6272 1.93482 9.97391 1.25 8.25 1.25ZM8.25 12.75H3.25V7.75C3.25 6.76109 3.54324 5.79439 4.09265 4.97215C4.64206 4.1499 5.42295 3.50904 6.33658 3.1306C7.25021 2.75216 8.25555 2.65315 9.22545 2.84607C10.1954 3.039 11.0863 3.5152 11.7855 4.21447C12.4848 4.91373 12.961 5.80464 13.1539 6.77455C13.3469 7.74445 13.2478 8.74979 12.8694 9.66342C12.491 10.577 11.8501 11.3579 11.0279 11.9073C10.2056 12.4568 9.23891 12.75 8.25 12.75ZM10.75 6.75C10.75 6.94891 10.671 7.13968 10.5303 7.28033C10.3897 7.42098 10.1989 7.5 10 7.5H6.25C6.05109 7.5 5.86032 7.42098 5.71967 7.28033C5.57902 7.13968 5.5 6.94891 5.5 6.75C5.5 6.55109 5.57902 6.36032 5.71967 6.21967C5.86032 6.07902 6.05109 6 6.25 6H10C10.1989 6 10.3897 6.07902 10.5303 6.21967C10.671 6.36032 10.75 6.55109 10.75 6.75ZM10.75 9.25C10.75 9.44891 10.671 9.63968 10.5303 9.78033C10.3897 9.92098 10.1989 10 10 10H6.25C6.05109 10 5.86032 9.92098 5.71967 9.78033C5.57902 9.63968 5.5 9.44891 5.5 9.25C5.5 9.05109 5.57902 8.86032 5.71967 8.71967C5.86032 8.57902 6.05109 8.5 6.25 8.5H10C10.1989 8.5 10.3897 8.57902 10.5303 8.71967C10.671 8.86032 10.75 9.05109 10.75 9.25Z"
                  fill="#A5AEBC"
                />
              </svg>
              <div className="flex items-center">
                <span className="text-secondary !text-left !text-[11px] !font-semibold">
                  COMMENTS
                </span>
              </div>
            </div>

            <div className="flex flex-col gap-[12px]">
              {/* <div className='flex items-center'>
                <span className='text-secondary !italic !text-[12px] !font-normal !leading-[18px]'>Request opened - {requestDetailsData?.request?.requested_on}</span>
              </div>*/}
              {companySubmissionDetailData?.submission?.comments?.length > 0 &&
                companySubmissionDetailData?.submission?.comments.map(
                  (item) => (
                    <div
                      key={item.commented_on}
                      className="flex flex-start gap-[10px]"
                    >
                      <div className="w-[40px] h-[40px] flex justify-center items-center rounded-full bg-[#BD3CFF] bg-opacity-20">
                        <span className="flex w-[40px] h-[40px] items-center justify-center text-primary !text-[14px] !font-semibold !text-[#BD3CFF]">
                          <span>{getInitials(item.commented_by)}</span>
                        </span>
                      </div>
                      <div className="flex flex-col">
                        <div className="flex gap-[4px]">
                          <span className="text-secondary !text-left !text-[#FFFFFF] !font-medium !leading-[21px]">
                            {item.commented_by}
                          </span>
                          <span className="text-secondary !text-left !font-medium !leading-[21px]">
                            {formatDate(item.commented_on)}
                          </span>
                        </div>
                        <span className="text-secondary !text-left">
                          {item.content}
                        </span>
                      </div>
                    </div>
                  )
                )}
              {/* <div className='flex items-center'>
                <span className='text-secondary !italic !text-[12px] !font-normal !leading-[18px]'>Request closed - Oct 26, 2022</span>
              </div>*/}
            </div>

            <div className="w-full flex flex-col p-4 border-[1px] border-[#596073] rounded-[16px]">
              <textarea
                className="!h-[100px] p-0 scrollbar-hide w-full resize-none border-none focus:ring-0 bg-[#363D50]"
                onChange={(e) => {
                  setWords(e.target.value);
                }}
                onKeyDown={handleKeyDown}
                placeholder={"Write comment"}
                value={Words}
              />
              <hr className="border-[#41485C]" />
              <div className="flex justify-between pt-[17px]">
                <span className="text-secondary text-left">
                  {Words.length}/500
                </span>
                <Button
                  onClick={postComment}
                  className={"!w-[fit-content] !h-[fit-content]"}
                  secondary={true}
                >
                  Send
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubmittedServicesInfoModel;
